module.exports = __webpack_public_path__ + "static/media/page05_and06_back_new.1295a216.jpg";